import SurveyButton from "./SurveyButton";

/**
 * Next button for the survey.
 *
 * @note This button needs to use the theme from the database, which is structured
 * differently than the theme define in `src/theme.js`.
 * @param {object} props
 * @param {{ buttonBackgroundColor: string; buttonTextColor: string; }} props.colorTheme The theme for the button.
 * @param {React.MouseEventHandler<HTMLButtonElement> | undefined} props.handleOnClick Handler for the button click event.
 */
function SurveyNextButton({ colorTheme, handleOnClick, size }) {
    return (
        <SurveyButton colorTheme={colorTheme} handleOnClick={handleOnClick} size={size}>
            Next
        </SurveyButton>
    );
}

export default SurveyNextButton;
